import { Outlet } from "react-router-dom";
import BottomNav from "./BottomNav";
import TopNav from "./TopNav";
import CookieConsent from "./CookieConsent";

export function AppLayout({ withNav = true }) {
  return (
    <div className="app-shell md:bg-transparent md:shadow-none pb-36 md:pb-0">
      {withNav && <TopNav />}
      <div className="page-enter">
        <Outlet />
      </div>
      {withNav && <BottomNav />}
      <CookieConsent />
    </div>
  );
}

export default AppLayout;
